import { render, staticRenderFns } from "./FornecedoresVinculados.vue?vue&type=template&id=e9654696&"
import script from "./FornecedoresVinculados.vue?vue&type=script&lang=js&"
export * from "./FornecedoresVinculados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports